var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2 mx-2"},[_c('label',{staticClass:"font-weight-bolder text-primary"},[_vm._v("Commentaire : ")]),_c('span',[_vm._v(" "+_vm._s(_vm.commentField)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }